import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-nyjgpz",
  "use": "icon-nyjgpz-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-nyjgpz\"><defs><style type=\"text/css\"></style></defs><path d=\"M576 512h128v128h-128v128h-128v-128h-128v-128h128v-32L313.429333 345.6l89.6-89.6 108.842667 108.8L620.672 256l89.6 89.6-134.272 134.314667v32zM512 1024a512 512 0 1 1 512-512 513.621333 513.621333 0 0 1-512 512z m0-128a384 384 0 1 0-384-384 385.237333 385.237333 0 0 0 384 384z\" p-id=\"968\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol